import { Box, Link, Typography } from '@mui/material';
import { InfoTooltip } from '~/components/InfoTooltip/InfoTooltip';
import { commonStyles } from '~/theme/styles/commonStyles';

interface IAddressCodeLabelProps {
  label: string;
  tooltipTitle: string;
}

const AddressCodeLabel = ({ label, tooltipTitle }: IAddressCodeLabelProps) => {
  return (
    <Box sx={{ ...commonStyles.centerFlexContainer, gap: 1 }}>
      <Typography
        variant="body2"
        sx={{ ...commonStyles.centerFlexContainer, gap: 1, position: 'relative' }}
      >
        {label}
        <InfoTooltip
          title={
            <Typography variant="body2">
              {tooltipTitle}
              <Link
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  color: 'lightblue',
                  textDecorationColor: 'lightblue',
                }}
                href="https://directory.org.ua/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Перейти за посиланням
              </Link>
            </Typography>
          }
          iconStyles={() => ({ height: 20 })}
        />
      </Typography>
    </Box>
  );
};

export default AddressCodeLabel;
